<template>
  <v-container>
    <v-row v-for="i in 5" :key = i>
      <v-col md=2> {{RatingDescription[i-1].text}} </v-col>
      <v-col> <v-progress-linear :value="calculatePercentageForRate(6-i)" color="white" height="13px" /> </v-col>
      <v-col md=2> <v-rating readonly dense :value=6-i :size=18 color="white" empty-icon="" /> </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "FeedbackRatingComponent",
  props: {
    valuesList: {
      default:() => [
        ],
      type: Array,
      required: false
    },
  },
  data() {
    return {
      RatingDescription: [
        {text: this.$root.$t('feedback_page.rating_text.highest')},
        {text: this.$root.$t('feedback_page.rating_text.high')},
        {text: this.$root.$t('feedback_page.rating_text.mid')},
        {text: this.$root.$t('feedback_page.rating_text.low')},
        {text: this.$root.$t('feedback_page.rating_text.lowest')},
      ],
    }
  },
  computed: {
    RatingsForStage() {
      return this.$store.getters.getRatings
    }
  },
  methods: {
    countRatingsWithRate(rate) {
      return (this.RatingsForStage.filter(val => val.rating === rate)).length
    },
    calculatePercentageForRate(rate) {
      let ratings = this.RatingsForStage
      let numRatings = ratings.length
      let numRatingsWithRate = (ratings.filter(val => val.rating === rate)).length
      let percent = Math.round(numRatingsWithRate / numRatings * 100)
      return percent
    }
  }
}
</script>

<style scoped>

</style>
